<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get('shared.workPlans')}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get('shared.dashboard')}}</span>
        </li>
        <li>
          <i class="fa fa-book"></i>
          <span>{{$ml.get('shared.definitions')}}</span>
        </li>
        <li>
          <span>{{$ml.get('shared.workPlans')}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-4">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{$ml.get('workPlans.workPlanList')}}</span>
              </h3>
              <div class="box-tools pull-right">
              </div>
            </div>
            <div class="box-body">
              <input
                  type="text"
                  :placeholder="$ml.get('general.search')"
                  v-model="searchText"
                  class="form-control"
                  autocomplete="false"
                  style="margin-bottom:10px;"
                />
              <div
                v-show="workGroupList.length > 0"
                class="table-responsive no-padding"
                :style="windowHeightSize"
              >
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="workGroup2 in workGroupList" :key="workGroup2.id">
                      <td>{{workGroup2.shortCode}}</td>
                      <td>{{workGroup2.name}}</td>
                      <td>
                        <span v-show="workGroup2.isPeriod" class="label label-primary">{{$ml.get('workPlans.period')}}</span>
                        <span
                          v-show="!workGroup2.isPeriod"
                          class="label label-success"
                        >{{$ml.get('workPlans.singlePlan')}}</span>
                      </td>
                      <td class="pull-right">
                        <button
                          @click="getWorkGroup(workGroup2.id)"
                          type="button"
                          class="btn btn-primary btn-sm"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="workGroupList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i> {{$ml.get('workPlans.workPlanNotRecord')}}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="box box-primary" id="capavardiya">
            <div class="box-header with-border">
              <h3 class="box-title">
                <span>{{$ml.get('workPlans.workPlanInfo')}}</span>
              </h3>
              <div class="pull-left"></div>
              <div class="box-tools pull-right">
                <button v-show="authControl == 0" @click="newWorkGroup()" class="btn btn-sm btn-warning ">{{$ml.get('workPlans.newWorkPlan')}}</button>
              </div>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>{{$ml.get('workPlans.workPlanModel')}}</label>
                    <select @change="changeWorkGroupModel($event)" class="form-control">
                      <option
                        :selected="workGroup.model == 0 || workGroup.model == null"
                        :value="0"
                      >{{$ml.get('general.select')}}</option>
                      <option
                        :selected="workGroup.model == 1"
                        :value="1"
                      >{{$ml.get('workPlans.defaultWorkPlanModel')}}</option>
                      <option :selected="workGroup.model == 2" :value="2">{{$ml.get('workPlans.workGroupModel')}}</option>
                      <option :selected="workGroup.model == 3" :value="3">{{$ml.get('workPlans.hourBasedPlanningModel')}}</option>
                      <option
                        :selected="workGroup.model == 4"
                        :value="4"
                      >{{$ml.get('workPlans.freelanceModelWithHourlyInterval')}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div
                    v-show="workGroup.model == 1"
                    class="info-box"
                    style="background-color:#3C8DBC; color:#fff;"
                  >
                    <span class="info-box-icon">
                      <a class="step step-primary">
                        <i class="fa fa-check-circle"></i>
                      </a>
                    </span>
                    <div class="info-box-content">
                      <span class="info-box-text">{{$ml.get('workPlans.defaultWorkPlanModel')}}</span>
                      <span
                        class="info-box-number"
                        style="font-style:italic;"
                      >{{$ml.get('workPlans.plan1Title')}}</span>
                      <span
                        class="progress-description"
                        style="padding-top:5px;"
                      >{{$ml.get('workPlans.plan1Description')}}</span>
                    </div>
                  </div>
                  <div v-show="workGroup.model == 2" class="info-box bg-red">
                    <span class="info-box-icon">
                      <a class="step step-danger">
                        <i class="fa fa-check-circle"></i>
                      </a>
                    </span>
                    <div class="info-box-content">
                      <span class="info-box-text">{{$ml.get('workPlans.workGroupModel')}}</span>
                      <span
                        class="info-box-number"
                        style="font-style:italic;"
                      >{{$ml.get('workPlans.plan2Title')}}</span>
                      <span
                        class="progress-description"
                        style="padding-top:5px;"
                      >{{$ml.get('workPlans.plan2Description')}}</span>
                    </div>
                  </div>
                  <div v-show="workGroup.model == 3" class="info-box bg-yellow">
                    <span class="info-box-icon">
                      <a class="step step-warning">
                        <i class="fa fa-check-circle"></i>
                      </a>
                    </span>
                    <div class="info-box-content">
                      <span class="info-box-text">{{$ml.get('workPlans.hourBasedPlanningModel')}}</span>
                      <span class="info-box-number" style="font-style:italic;">{{$ml.get('workPlans.plan3Title')}}</span>
                      <span
                        class="progress-description"
                        style="padding-top:5px;"
                      >{{$ml.get('workPlans.plan3Description')}}</span>
                    </div>
                  </div>
                  <div v-show="workGroup.model == 4" class="info-box bg-green">
                    <span class="info-box-icon">
                      <a class="step step-success">
                        <i class="fa fa-check-circle"></i>
                      </a>
                    </span>
                    <div class="info-box-content">
                      <span class="info-box-text">{{$ml.get('workPlans.freelanceModelWithHourlyInterval')}}</span>
                      <span
                        class="info-box-number"
                        style="font-style:italic;"
                      >{{$ml.get('workPlans.plan4Title')}}</span>
                      <span
                        class="progress-description"
                        style="padding-top:5px;"
                      >{{$ml.get('workPlans.plan4Description')}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="workGroup.model != 0" class="nav-tabs-custom">
                <ul class="nav nav-tabs">
                  <li class="active">
                    <a href="#tab_2" data-toggle="tab" aria-expanded="false">{{$ml.get('workPlans.details')}}</a>
                  </li>
                  <li class>
                    <a href="#tab_3" data-toggle="tab" aria-expanded="false">{{$ml.get('workPlans.settings')}}</a>
                  </li>
                  <li class v-show="workGroup.model != 3 && workGroup.model != 4">
                    <a href="#tab_4" data-toggle="tab" aria-expanded="false">{{$ml.get('workPlans.plan')}}</a>
                  </li>
                  <li class="pull-right"></li>
                </ul>
                <div class="tab-content">
                  <div class="tab-pane active" id="tab_2">
                    <div v-show="workGroup.model != 2" class="col-sm-12">
                      <span class="checkbox" style="margin-bottom:10px;">
                        <label style="margin-left:20px;">
                          <input
                            :checked="workGroup.firstEntryLastExit"
                            @change="workGroup.firstEntryLastExit==true ? workGroup.firstEntryLastExit=false : workGroup.firstEntryLastExit=true"
                            type="checkbox"
                          />
                          {{$ml.get('workPlans.calculateBasedOnFirstEntryAndLastExit')}}
                        </label>
                      </span>
                    </div>
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label>{{$ml.get('workPlans.shortCode')}}</label>
                        <input v-model="workGroup.shortCode" type="text" class="form-control" />
                      </div>
                    </div>
                    <div class="col-sm-9">
                      <div class="form-group">
                        <label>{{$ml.get('workPlans.workPlanName')}}</label>
                        <input v-model="workGroup.name" type="text" class="form-control" />
                      </div>
                    </div>
                    <div v-show="workGroup.model == 1 || workGroup.model == 3">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label>{{$ml.get('workPlans.entryTime')}}</label>
                          <input type="time" class="form-control" v-model="workGroup.entryTime"/>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label>{{$ml.get('workPlans.exitTime')}}</label>
                          <input type="time" class="form-control" v-model="workGroup.exitTime"/>
                        </div>
                      </div>
                    </div>
                    <div v-show="workGroup.model == 1 || workGroup.model == 3">
                      <div class="col-sm-12">
                        <h4>{{$ml.get('workPlans.tolerances')}}</h4>
                        <hr style="margin-top:5px;"/>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label>{{$ml.get('workPlans.earlyEntryTolerance')}}</label>
                          <input type="time" class="form-control" v-model="workGroup.earlyEntryTime"/>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label>{{$ml.get('workPlans.earlyExitTolerance')}}</label>
                          <input type="time" class="form-control" v-model="workGroup.earlyExitTime"/>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label>{{$ml.get('workPlans.lateEntryTolerance')}}</label>
                          <input type="time" class="form-control" v-model="workGroup.lateEntryTime"/>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label>{{$ml.get('workPlans.lateExitTolerance')}}</label>
                          <input type="time" class="form-control" v-model="workGroup.lateExitTime"/>
                        </div>
                      </div>
                    </div>
                    <div v-show="workGroup.model == 1">
                      <div class="col-sm-12">
                        <h4>{{$ml.get('workPlans.mealBreakTime')}}</h4>
                        <hr style="margin-top:5px;"/>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>{{$ml.get('workPlans.mealStartTime')}}</label>
                          <input type="time" class="form-control" v-model="workGroup.foodStartTime"/>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>{{$ml.get('workPlans.mealEndTime')}}</label>
                          <input type="time" class="form-control" v-model="workGroup.foodEndTime"/>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>{{$ml.get('workPlans.totalMealTime')}}</label>
                          <input type="time" class="form-control" v-model="workGroup.foodTotalTime"/>
                        </div>
                      </div>
                    </div>
                    <div v-show="workGroup.model == 4" class="col-sm-12">
                      <div class="form-group">
                        <label>{{$ml.get('workPlans.totalWorkTime')}}</label>
                        <input type="time" class="form-control" v-model="workGroup.totalWorkTime"/>
                      </div>
                    </div>
                    <div v-show="workGroup.model == 3 || workGroup.model == 4">
                      <div class="col-sm-12">
                        <h4>{{$ml.get('workPlans.breakTolerances')}}</h4>
                      </div>
                      <div class="col-sm-12">
                        <div class="alert alert-info alert-dismissible">
                          <button
                            type="button"
                            class="close"
                            data-dismiss="alert"
                            aria-hidden="true"
                          >×</button>
                          <i class="fa fa-info-circle"></i> {{$ml.get('workPlans.createSettingsForDeservedBreaks')}}
                        </div>
                      </div>
                      <div class="col-sm-6" style="margin-bottom:10px;">
                        <div class="input-group">
                          <input type="time" class="form-control" v-model="selectedBreakHourlyWork"/>
                          <span class="input-group-addon">{{$ml.get('workPlans.forHourlyWork')}}</span>
                        </div>
                      </div>
                      <div class="col-sm-6" style="margin-bottom:10px;">
                        <div class="input-group">
                          <input type="time" class="form-control" v-model="selectedBreak"/>
                          <span class="input-group-addon">{{$ml.get('workPlans.break')}}</span>
                        </div>
                      </div>
                      <div class="col-sm-12" style="margin-bottom:10px;">
                        <button v-show="authControl == 0"
                          @click="addBreakTolerance()"
                          class="btn btn-success  pull-right"
                          style="width:120px;"
                        >
                          <i class="fa fa-plus"></i> {{$ml.get('general.add')}}
                        </button>
                      </div>
                      <div class="col-sm-12">
                        <div
                          v-show="breakToleranceList.length > 0"
                          class="table-responsive no-padding"
                          style="max-height:250px; overflow:auto;"
                        >
                          <table class="table table-hover">
                            <thead>
                              <th>{{$ml.get('workPlans.hourlyWork')}}</th>
                              <th>{{$ml.get('workPlans.breakTolerance')}}</th>
                              <th></th>
                            </thead>
                            <tbody>
                              <tr v-for="(break2, index) in breakToleranceList" :key="index">
                                <td>{{break2.hourlyWorkTime | toDateFormatGet("ss:dd")}}</td>
                                <td>{{break2.breakTolerance | toDateFormatGet("ss:dd")}}</td>
                                <td class="pull-right">
                                  <button v-show="authControl == 0"
                                    @click="deleteBreakTolerance(index, break2.id)"
                                    type="button"
                                    class="btn btn-danger btn-sm"
                                  >
                                    <i class="fa fa-remove"></i>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div v-show="breakToleranceList.length == 0" class="callout callout-info">
                          <i class="fa fa-info-circle"></i> {{$ml.get('workPlans.notRecord')}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- /.tab-pane -->
                  <div class="tab-pane" id="tab_3">
                    <div v-show="workGroup.model == 2">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label>{{$ml.get('workPlans.durationOfAbsence')}}</label>
                          <input type="time" class="form-control" v-model="workGroup.discontinuityDayTime"/>
                        </div>
                      </div>
                    </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label>{{$ml.get('workPlans.skipTheDayTime')}}</label>
                          <input type="time" class="form-control" v-model="workGroup.dayOffHour"/>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label>{{$ml.get('workPlans.solsticeTime')}}</label>
                          <input type="time" class="form-control" v-model="workGroup.solsticeHour"/>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label>{{$ml.get('workPlans.maxLimit')}}</label>
                          <input type="time" class="form-control" v-model="workGroup.maxLimit"/>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label>{{$ml.get('workPlans.minLimit')}}</label>
                          <input type="time" class="form-control" v-model="workGroup.minLimit"/>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <span class="form-control checkbox" style="margin-bottom:10px;">
                          <label style="margin-left:20px;">
                            <input
                              :checked="workGroup.acceptToEntryDay"
                              @change="workGroup.acceptToEntryDay==true ? workGroup.acceptToEntryDay=false : workGroup.acceptToEntryDay=true"
                              type="checkbox"
                            />
                            {{$ml.get('workPlans.basedOnEntryDay')}}
                          </label>
                        </span>
                      </div>
                      <div class="col-sm-6">
                        <span class="form-control checkbox" style="margin-bottom:10px;">
                          <label style="margin-left:20px;">
                            <input
                              :checked="workGroup.accessDoorControl"
                              @change="workGroup.accessDoorControl==true ? workGroup.accessDoorControl=false : workGroup.accessDoorControl=true"
                              type="checkbox"
                            />
                            {{$ml.get('workPlans.checkTheDoors')}}
                          </label>
                        </span>
                      </div>
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label>{{$ml.get('workPlans.toleranceToReduceTheSameMovementsToOne')}}</label>
                          <input type="time" class="form-control" v-model="workGroup.oneOfAllLog"/>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <span class="form-control checkbox" style="margin-bottom:10px;">
                          <label style="margin-left:20px;">
                            <input
                              :checked="workGroup.deleteDifferentDoors"
                              @change="workGroup.deleteDifferentDoors==true ? workGroup.deleteDifferentDoors=false : workGroup.deleteDifferentDoors=true"
                              type="checkbox"
                            />
                            {{$ml.get('workPlans.includeDifferentDoorsInDeleting')}}
                          </label>
                        </span>
                      </div>
                      <div class="col-sm-6">
                        <span class="form-control checkbox" style="margin-bottom:10px;">
                          <label style="margin-left:20px;">
                            <input
                              :checked="workGroup.noDeleteOvertime"
                              @change="workGroup.noDeleteOvertime==true ? workGroup.noDeleteOvertime=false : workGroup.noDeleteOvertime=true"
                              type="checkbox"
                            />
                            {{$ml.get('workPlans.dontDeleteConfirmedOvertimes')}}
                          </label>
                        </span>
                      </div>
                    <div v-show="workGroup.model == 2">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="alert alert-info alert-dismissible">
                            <button
                              type="button"
                              class="close"
                              data-dismiss="alert"
                              aria-hidden="true"
                            >×</button>
                            <i class="icon fa fa-info"></i> {{$ml.get('workPlans.selectThePlansYouWantToIncludeInTheGroup')}}
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-8">
                          <select @change="changeWorkGroups($event)" class="form-control">
                            <option
                              :selected="selectedWorkGroup == 0 || selectedWorkGroup == null"
                              :value="null"
                            >{{$ml.get('general.select')}}</option>
                            <option
                              v-for="workGroup4 in extraWorkGroupList"
                              :key="workGroup4.id"
                              :value="workGroup4.id"
                            >{{workGroup4.shortCode}} - {{workGroup4.name}}</option>
                          </select>
                        </div>
                        <div class="col-sm-4">
                          <button v-show="authControl == 0"
                            @click="addExtraWork()"
                            class="btn btn-success "
                            style="width:100%"
                          >
                            <i class="fa fa-plus"></i> {{$ml.get('general.add')}}
                          </button>
                        </div>
                      </div>
                      <div class="row" style="margin-top:10px;">
                        <div class="col-sm-12">
                          <div
                            v-show="extraWorkList.length > 0"
                            class="table-responsive no-padding"
                            style="max-height:250px; overflow:auto;"
                          >
                            <table class="table table-hover">
                              <thead>
                                <th>{{$ml.get('workPlans.workPlanName')}}</th>
                                <th></th>
                              </thead>
                              <tbody>
                                <tr v-for="(extraWork, index) in extraWorkList" :key="index">
                                  <td>
                                    <span v-text="workGroupGetNameToId(extraWork.subShiftId)"></span>
                                  </td>
                                  <td class="pull-right">
                                    <button v-show="authControl == 0"
                                      @click="deleteExtraWork(index, extraWork.id)"
                                      type="button"
                                      class="btn btn-danger btn-sm "
                                    >
                                      <i class="fa fa-remove"></i>
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div v-show="extraWorkList.length == 0" class="callout callout-info">
                            <i class="fa fa-info-circle"></i> {{$ml.get('workPlans.notRecord')}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-show="workGroup.model == 1">
                      <div class="col-sm-12">
                        <h4 style="">{{$ml.get('workPlans.payrollDetails')}}</h4>
                        <hr style="margin-top:5px;"/>
                        <div class="input-group" style="margin-bottom:10px">
                          <input type="time" class="form-control" v-model="selectedPayrollStartTime"/>
                          <span class="input-group-addon">-</span>
                          <input type="time" class="form-control" v-model="selectedPayrollEndTime"/>
                        </div>
                        <div class="input-group" style="margin-bottom:10px">
                          <span class="input-group-addon">{{$ml.get('workPlans.currentDefinitionBetweenSelectedHours')}} :</span>
                          <select @change="changePayrolls($event)" class="form-control">
                            <option :selected="selectedPayrollId == null" :value="null">{{$ml.get('general.select')}}</option>
                            <option
                              v-for="payroll in payrollList"
                              :key="payroll.id"
                              :value="payroll.id"
                            >{{payroll.shortCode}} - {{payroll.name}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <span class="form-control checkbox" style="margin-bottom:10px;">
                          <label style="margin-left:20px;">
                            <input
                              :checked="selectedHakedis"
                              @change="selectedHakedis==true ? selectedHakedis=false : selectedHakedis=true"
                              type="checkbox"
                            />
                            {{$ml.get('workPlans.whenItDoesntComePerceiveItAsADeserved')}}
                          </label>
                        </span>
                      </div>
                      <div class="col-sm-6">
                        <button v-show="authControl == 0"
                          @click="addExtraPayroll()"
                          class="btn btn-success "
                          style="width:100%"
                        >
                          <i class="fa fa-plus"></i> {{$ml.get('general.add')}}
                        </button>
                      </div>
                      <div class="col-sm-12">
                        <div
                          v-show="extraPayrollList.length > 0"
                          class="table-responsive no-padding"
                          style="max-height:250px; overflow:auto;"
                        >
                          <table class="table table-hover">
                            <thead>
                              <th>{{$ml.get('workPlans.start')}}</th>
                              <th>{{$ml.get('workPlans.end')}}</th>
                              <th>{{$ml.get('workPlans.payrollType')}}</th>
                              <th>{{$ml.get('workPlans.deserve')}}</th>
                              <th></th>
                            </thead>
                            <tbody>
                              <tr v-for="(extraPayroll, index) in extraPayrollList" :key="index">
                                <td>{{extraPayroll.startDate | toDateFormatGet("ss:dd")}}</td>
                                <td>{{extraPayroll.endDate | toDateFormatGet("ss:dd")}}</td>
                                <td>
                                  <span v-text="payrollGetNameToId(extraPayroll.payrollId)"></span>
                                </td>
                                <td>
                                  <i v-show="extraPayroll.hakedis" class="fa fa-check"></i>
                                  <i v-show="!extraPayroll.hakedis" class="fa fa-remove"></i>
                                </td>
                                <td class="pull-right">
                                  <button v-show="authControl == 0"
                                    @click="deleteExtraPayroll(index, extraPayroll.id)"
                                    type="button"
                                    class="btn btn-danger btn-sm"
                                  >
                                    <i class="fa fa-remove"></i>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div v-show="extraPayrollList.length == 0" class="callout callout-info">
                          <i class="fa fa-info-circle"></i> {{$ml.get('workPlans.notRecord')}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- /.tab-pane -->
                  <div
                    v-show="workGroup.model != 3 && workGroup.model != 4"
                    class="tab-pane"
                    id="tab_4"
                  >
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label>{{$ml.get('workPlans.planType')}}</label>
                        <select @change="changePeriod($event)" class="form-control">
                          <option
                            value="false"
                            :selected="workGroup.isPeriod == false"
                          >{{$ml.get('workPlans.singlePlan')}}</option>
                          <option value="true" :selected="workGroup.isPeriod == true">{{$ml.get('workPlans.period')}}</option>
                        </select>
                      </div>
                    </div>
                    <div v-show="workGroup.isPeriod == true">
                      <div class="col-sm-12">
                        <h4>{{$ml.get('workPlans.periodDistribution')}}</h4>
                      </div>
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label>{{$ml.get('workPlans.periodStartDate')}}</label>
                          <input type="date" class="form-control" v-model="workGroup.periodStartDate"/>
                        </div>
                        <hr />
                      </div>
                      <div class="col-sm-5">
                        <select @change="changePeriodDetails($event)" class="form-control">
                          <option :selected="selectedPeriodValue == null" :value="null">{{$ml.get('general.select')}}</option>
                          <option
                            v-for="(periodDetail,index) in periodDetailList"
                            :key="index"
                            :value="periodDetail.id + '-' +periodDetail.isAllowence"
                          >
                            <span v-if="periodDetail.isAllowence">{{$ml.get('workPlans.allowence')}} |</span>
                            {{periodDetail.name}}
                          </option>
                        </select>
                      </div>
                      <div class="col-sm-3">
                        <div class="input-group">
                          <input v-model="selectedDay" type="number" min="1" class="form-control" />
                          <span class="input-group-addon">{{$ml.get('workPlans.day')}}</span>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <button v-show="authControl == 0"
                          @click="addPeriod()"
                          class="btn btn-success "
                          style="width:100%;"
                        >
                          <i class="fa fa-plus"></i> {{$ml.get('general.add')}}
                        </button>
                      </div>
                      <div class="col-sm-12" style="margin-top:10px;">
                        <div
                          v-show="periodList.length > 0"
                          class="table-responsive no-padding"
                          style="max-height:250px; overflow:auto;"
                        >
                          <table class="table table-hover">
                            <thead>
                              <th>{{$ml.get('workPlans.name')}}</th>
                              <th>{{$ml.get('workPlans.dayCount')}}</th>
                              <th></th>
                            </thead>
                            <tbody>
                              <tr v-for="(period, index) in periodList" :key="index">
                                <td>
                                  <span
                                    v-text="periodDetailGetNameToId(period.subShiftId, period.isAllowence)"
                                  ></span>
                                </td>
                                <td>{{period.day}}</td>
                                <td class="pull-right">
                                  <button v-show="authControl == 0"
                                    @click="deletePeriod(index, period.id)"
                                    type="button"
                                    class="btn btn-danger btn-sm"
                                  >
                                    <i class="fa fa-remove"></i>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div v-show="periodList.length == 0" class="callout callout-info">
                          <i class="fa fa-info-circle"></i> {{$ml.get('workPlans.notRecord')}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- /.tab-pane -->
                  <!-- /.tab-content -->
                </div>
                <div class="row" style="margin-bottom:10px;">
                  <div class="col-sm-12" align="center"></div>
                </div>
                <div class="overlay" id="load" hidden>
                  <i class="fa fa-refresh fa-spin"></i>
                </div>
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoadingDetail">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-footer">
              <div class="pull-right">
                <button
                  v-show="!isNewWorkGroup && authControl == 0"
                  type="button"
                  data-toggle="modal"
                  data-target="#modal-sil"
                  class="btn btn-sm btn-danger "
                  style="margin: 5px; width:120px;"
                >{{$ml.get('general.delete')}}</button>
                <button
                  v-show="isNewWorkGroup && authControl == 0"
                  type="button"
                  data-toggle="modal"
                  data-target="#modal-kaydet"
                  class="btn btn-sm btn-success "
                  style="margin: 5px; width:120px;"
                >{{$ml.get('general.save')}}</button>
                <button
                  v-show="!isNewWorkGroup && authControl == 0"
                  type="button"
                  data-toggle="modal"
                  data-target="#modal-guncelle"
                  class="btn btn-sm btn-success "
                  style="margin: 5px; width:120px;"
                >{{$ml.get('general.update')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-info fade" id="modal-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.update')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{this.workGroup.name}}</span>
              </div>
              <br />
              <p></p>
              <span>{{$ml.get('workPlans.isContinueWorkPlanUpdate')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="saveWorkGroup()" class="btn btn-info" data-dismiss="modal">
                <i class="fa fa-refresh"></i>
                <span>{{$ml.get('general.update')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-success fade" id="modal-kaydet">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.save')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <p>{{this.workGroup.name}}</p>
              <span>{{$ml.get('workPlans.isContinueWorkPlanSave')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="saveWorkGroup()" class="btn btn-success" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{$ml.get('general.save')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-sil">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.delete')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{this.workGroup.name}}</span>
              </div>
              <br />
              <p></p>
              <span>{{$ml.get('workPlans.isContinueWorkPlanDelete')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="deleteWorkGroup()" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{$ml.get('general.delete')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      searchText: "",
      workGroup: {
        model: 0,
        id: null,
        name: "",
        shortCode: "",
        isPeriod: false,
        periodStartDate: null,
        entryTime: "00:00",
        exitTime: "00:00",
        earlyEntryTime: "00:05",
        earlyExitTime: "00:05",
        lateEntryTime: "00:05",
        lateExitTime: "00:05",
        foodStartTime: "00:00",
        foodEndTime: "00:00",
        foodTotalTime: "00:00",
        totalWorkTime: "00:00",
        totalBreakTime: "",
        totalOverTime: "",
        firstEntryLastExit: false,
        dayOffHour: "00:00",
        solsticeHour: "00:00",
        discontinuityDayTime: "07:30",
        maxLimit: "00:00",
        minLimit: "00:15",
        acceptToEntryDay: false,
        accessDoorControl: false,
        oneOfAllLog: "00:05",
        deleteDifferentDoors: false,
        noDeleteOvertime: false,
        breakTolerances: [],
        extraWorks: [],
        periods: [],
        extraPayrolls: []
      },
      workGroups: [],
      payrolls: [],
      periodDetails: [],
      allowences: [],
      selectedPayrollStartTime: "00:00",
      selectedPayrollEndTime: "00:00",
      selectedPayrollId: null,
      selectedBreakHourlyWork: "00:00",
      selectedBreak: "00:00",
      selectedHakedis: false,
      selectedWorkGroup: null,
      selectedDay: 1,
      selectedPeriodisAllowence: false,
      selectedPeriodValue: null,
      isNewWorkGroup: true
    };
  },
  filters: {
    toDateFormatGet(str, format) {
      if (str == "" || str == null) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        if (str.length > 5) {
          str = new Date(str);
          var saat =
            str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika =
            str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        } else {
          str = new Date("1900-01-01 " + str.replace("Z", ""));
          var saat =
            str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika =
            str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          var saniye =
            str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
          return saat + ":" + dakika + ":" + saniye;
        }
      } else if (format == "ss:dd") {
        if (str.length > 5) {
          str = new Date(str);
          var saat =
            str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika =
            str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        } else {
          str = new Date("1900-01-01 " + str.replace("Z", ""));
          var saat =
            str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika =
            str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        }
      }
    },
    toDateFormatGetSTR(str, format) {
      if (!str) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = str.substr(8, 2);
        var ay = str.substr(5, 2);
        var yil = str.substr(0, 4);
        var saat = str.substr(11, 2);
        var dakika = str.substr(14, 2);
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = str.substr(8, 2);
        var ay = str.substr(5, 2);
        var yil = str.substr(0, 4);
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        var saat = str.substr(0, 2);
        var dakika = str.substr(3, 2);
        var saniye = str.substr(6, 2);
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.substr(0, 2);
        var dakika = str.substr(3, 2);
        return saat + ":" + dakika;
      }
    }
  },
  computed: {
    authControl(){
      return this.$store.getters.getAuthTanimlamalar;
    },
    workGroupList() {
      if(this.searchText){
        return this.workGroups.filter(item => {
          return this.searchText
            .toUpperCase()
            .split(" ")
            .every(v => item.name.toUpperCase().includes(v));
        });
      } else {
      return this.workGroups;
      }
    },
    extraWorkGroupList() {
      return this.workGroups.filter(item => {
        return item.model == 1;
      });
    },
    extraWorkList() {
      return this.workGroup.extraWorks;
    },
    periodList() {
      return this.workGroup.periods;
    },
    periodDetailList() {
      return this.periodDetails;
    },
    extraPayrollList() {
      return this.workGroup.extraPayrolls;
    },
    breakToleranceList() {
      return this.workGroup.breakTolerances;
    },
    payrollList() {
      return this.payrolls;
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    changePayrolls(event) {
      this.selectedPayrollId = event.target.value;
    },
    changeWorkGroups(event) {
      this.selectedWorkGroup = event.target.value;
    },
    changeWorkGroupModel(event) {
      this.workGroup.model = event.target.value;
    },
    changePeriodDetails(event) {
      var name = event.target.value;
      if (name.indexOf("true") == -1) {
        this.selectedPeriodisAllowence = false;
      } else {
        this.selectedPeriodisAllowence = true;
      }
      this.selectedPeriodValue = event.target.value.replace("-","").replace("true","").replace("false","");
    },
    changePeriod(event) {
      if(event.target.value == "true"){
        this.workGroup.isPeriod = true;
      } else {
        this.workGroup.isPeriod = false;
      }
    },
    payrollGetNameToId(id) {
      let payroll = this.payrolls.filter(item => {
        return item.id == id;
      });
      if (payroll != "" && payroll != null) {
        return payroll[0].name;
      } else {
        return "";
      }
    },
    workGroupGetNameToId(id) {
      let workGroup = this.workGroups.filter(item => {
        return item.id == id;
      });
      if (workGroup != "" && workGroup != null) {
        return workGroup[0].shortCode + " - " + workGroup[0].name;
      } else {
        return "";
      }
    },
    periodDetailGetNameToId(id, isAllowence) {
      if (isAllowence == true) {
        let allowence = this.allowences.filter(item => {
          return item.id == id;
        });
        if (allowence != "" && allowence != null) {
          return allowence[0].name;
        } else {
          return "";
        }
      } else {
        let workGroup = this.workGroups.filter(item => {
          return item.id == id;
        });
        if (workGroup != "" && workGroup != null) {
          return workGroup[0].shortCode + " - " + workGroup[0].name;
        } else {
          return "";
        }
      }
    },
    addBreakTolerance() {
      if (
        this.selectedBreakHourlyWork == "00:00" ||
        this.selectedBreakHourlyWork == "" ||
        this.selectedBreak == "00:00" ||
        this.selectedBreak == ""
      ) {
        alertify.warning(this.$ml.get('alerts.pleaseCheckTimes'));
        return;
      }
      let hourlyWorkTime = this.toDateFormat(
        this.selectedBreakHourlyWork,
        "ss:dd"
      );
      let breakTolerance = this.toDateFormat(this.selectedBreak, "ss:dd");
      let workGroupId = this.workGroup.id;
      this.workGroup.breakTolerances.push({
        id: null,
        hourlyWorkTime: hourlyWorkTime,
        breakTolerance: breakTolerance,
        workGroupId: workGroupId
      });
    },
    async deleteBreakTolerance(index, id) {
      if (id != null) {
        try {
          const response = await this.$axios.delete(
            "/WorkGroups/DeleteBreakTolerance/" + id
          );
          if (response.status == 200) {
            this.workGroup.breakTolerances.splice(index, 1);
            alertify.success(this.$ml.get('alerts.deletedSuccessfully'));
          } else {
            alertify.error(response.status + " - " + response.message);
          }
        } catch (error) {
          alertify.error("Hata Oluştu : " + error);
        }
      } else {
        this.workGroup.breakTolerances.splice(index, 1);
      }
    },
    addExtraPayroll() {
      if (this.selectedPayrollId == null) {
        alertify.warning(this.$ml.get('alerts.pleaseSelect'));
        return;
      }
      if (
        this.selectedPayrollStartTime == "" ||
        this.selectedPayrollEndTime == ""
      ) {
        alertify.warning(this.$ml.get('alerts.pleaseCheckTimes'));
        return;
      }
      let payrollId = this.selectedPayrollId;
      let payroll = this.payrolls.filter(function(item) {
        return item.id == payrollId;
      });
      let payrollType = payroll[0].type;
      let hakedis = this.selectedHakedis;
      let startDate = this.toDateFormat(this.selectedPayrollStartTime, "ss:dd");
      let endDate = this.toDateFormat(this.selectedPayrollEndTime, "ss:dd");
      let workGroupId = this.workGroup.id;
      this.workGroup.extraPayrolls.push({
        id: null,
        startDate: startDate,
        endDate: endDate,
        payrollId: payrollId,
        payrollType: payrollType,
        hakedis: hakedis,
        workGroupId: workGroupId,
        holidayId: null
      });
    },
    async deleteExtraPayroll(index, id) {
      if (id != null) {
        try {
          const response = await this.$axios.delete(
            "/WorkGroups/DeleteExtraPayroll/" + id
          );
          if (response.status == 200) {
            this.workGroup.extraPayrolls.splice(index, 1);
            alertify.success(this.$ml.get('alerts.deletedSuccessfully'));
          } else {
            alertify.error(response.status + " - " + response.message);
          }
        } catch (error) {
          alertify.error("Hata Oluştu : " + error);
        }
      } else {
        this.workGroup.extraPayrolls.splice(index, 1);
      }
    },
    addExtraWork() {
      if (this.selectedWorkGroup == null) {
        alertify.warning(this.$ml.get('alerts.pleaseSelect'));
        return;
      }
      let subShiftId = this.selectedWorkGroup;
      let workGroupId = this.workGroup.id;
      this.workGroup.extraWorks.push({
        id: null,
        subShiftId: subShiftId,
        workGroupId: workGroupId
      });
    },
    async deleteExtraWork(index, id) {
      if (id != null) {
        try {
          const response = await this.$axios.delete(
            "/WorkGroups/DeleteExtraWork/" + id
          );
          if (response.status == 200) {
            this.workGroup.extraWorks.splice(index, 1);
            alertify.success(this.$ml.get('alerts.deletedSuccessfully'));
          } else {
            alertify.error(response.status + " - " + response.message);
          }
        } catch (error) {
          alertify.error("Hata Oluştu : " + error);
        }
      } else {
        this.workGroup.extraWorks.splice(index, 1);
      }
    },
    addPeriod() {
      if (this.selectedPeriodValue == null) {
        alertify.warning(this.$ml.get('alerts.pleaseSelect'));
        return;
      }
      let subShiftId = this.selectedPeriodValue;
      let day = this.selectedDay;
      let isAllowence = this.selectedPeriodisAllowence;
      let workGroupId = this.workGroup.id;
      var index = this.workGroup.periods.length + 1;
      this.workGroup.periods.push({
        id: null,
        index: index,
        subShiftId: subShiftId,
        day: day,
        workGroupId: workGroupId,
        isAllowence: isAllowence
      });
    },
    async deletePeriod(index, id) {
      if (id != null) {
        try {
          const response = await this.$axios.delete(
            "/WorkGroups/DeletePeriod/" + id
          );
          if (response.status == 200) {
            this.workGroup.periods.splice(index, 1);
            alertify.success(this.$ml.get('alerts.deletedSuccessfully'));
          } else {
            alertify.error(response.status + " - " + response.message);
          }
        } catch (error) {
          alertify.error("Hata Oluştu : " + error);
        }
      } else {
        this.workGroup.periods.splice(index, 1);
      }
    },
    newWorkGroup() {
      this.isLoadingDetail = true;
      this.isNewWorkGroup = true;
      this.workGroup.model = 0;
      this.workGroup.shortCode = "";
      this.workGroup.name = "";
      this.workGroup.id = null;
      this.workGroup.isPeriod = false;
      this.workGroup.periodStartDate = null;
      this.workGroup.entryTime = "00:00";
      this.workGroup.exitTime = "00:00";
      this.workGroup.earlyEntryTime = "00:05";
      this.workGroup.earlyExitTime = "00:05";
      this.workGroup.lateEntryTime = "00:05";
      this.workGroup.lateExitTime = "00:05";
      this.workGroup.foodStartTime = "00:00";
      this.workGroup.foodEndTime = "00:00";
      this.workGroup.foodTotalTime = "00:00";
      this.workGroup.totalWorkTime = "00:00";
      this.workGroup.totalBreakTime = "";
      this.workGroup.totalOverTime = "";
      this.workGroup.firstEntryLastExit = false;
      this.workGroup.dayOffHour = "00:00";
      this.workGroup.solsticeHour = "00:00";
      this.workGroup.discontinuityDayTime = "07:30";
      this.workGroup.maxLimit = "17:00";
      this.workGroup.minLimit = "00:15";
      this.workGroup.acceptToEntryDay = false;
      this.workGroup.accessDoorControl = false;
      this.workGroup.oneOfAllLog = "00:05";
      this.workGroup.deleteDifferentDoors = false;
      this.workGroup.noDeleteOvertime = false;
      this.workGroup.breakTolerances = [];
      this.workGroup.extraWorks = [];
      this.workGroup.periods = [];
      this.workGroup.extraPayrolls = [];
      this.selectedPayrollStartTime = "00:00";
      this.selectedPayrollEndTime = "00:00";
      this.selectedPayrollId = null;
      this.selectedBreakHourlyWork = "00:00";
      this.selectedBreak = "00:00";
      this.selectedHakedis = false;
      this.selectedWorkGroup = null;
      this.selectedDay = 1;
      this.selectedPeriodisAllowence = false;
      this.selectedPeriodValue = null;
      this.isLoadingDetail = false;
    },
    async getWorkGroup(id) {
      try {
        this.isLoadingDetail = true;
        const response = await this.$axios.get("/WorkGroups/" + id);
        this.isNewWorkGroup = false;
        this.workGroup.id = id;
        this.workGroup.model = response.data.model;
        this.workGroup.name = response.data.name;
        this.workGroup.shortCode = response.data.shortCode;
        this.workGroup.isPeriod = response.data.isPeriod;
        this.workGroup.periodStartDate = response.data.periodStartDate
          ? this.toDateFormat(response.data.periodStartDate, "gg.aa.yyyy")
          : "";
        this.workGroup.entryTime = response.data.entryTime
          ? this.toDateFormat(response.data.entryTime, "ss:dd")
          : "";
        this.workGroup.exitTime = response.data.exitTime
          ? this.toDateFormat(response.data.exitTime, "ss:dd")
          : "";
        this.workGroup.earlyEntryTime = response.data.earlyEntryTime
          ? this.toDateFormat(response.data.earlyEntryTime, "ss:dd")
          : "";
        this.workGroup.earlyExitTime = response.data.earlyExitTime
          ? this.toDateFormat(response.data.earlyExitTime, "ss:dd")
          : "";
        this.workGroup.lateEntryTime = response.data.lateEntryTime
          ? this.toDateFormat(response.data.lateEntryTime, "ss:dd")
          : "";
        this.workGroup.lateExitTime = response.data.lateExitTime
          ? this.toDateFormat(response.data.lateExitTime, "ss:dd")
          : "";
        this.workGroup.foodStartTime = response.data.foodStartTime
          ? this.toDateFormat(response.data.foodStartTime, "ss:dd")
          : "";
        this.workGroup.foodEndTime = response.data.foodEndTime
          ? this.toDateFormat(response.data.foodEndTime, "ss:dd")
          : "";
        this.workGroup.foodTotalTime = response.data.foodTotalTime
          ? this.toDateFormat(response.data.foodTotalTime, "ss:dd")
          : "";
        this.workGroup.totalWorkTime = response.data.totalWorkTime
          ? this.toDateFormat(response.data.totalWorkTime, "ss:dd")
          : "";
        this.workGroup.totalBreakTime = response.data.totalBreakTime
          ? this.toDateFormat(response.data.totalBreakTime, "ss:dd")
          : "";
        this.workGroup.totalOverTime = response.data.totalOverTime
          ? this.toDateFormat(response.data.totalOverTime, "ss:dd")
          : "";
        this.workGroup.firstEntryLastExit = response.data.firstEntryLastExit;
        this.workGroup.dayOffHour = response.data.dayOffHour
          ? this.toDateFormat(response.data.dayOffHour, "ss:dd")
          : "";
        this.workGroup.solsticeHour = response.data.solsticeHour
          ? this.toDateFormat(response.data.solsticeHour, "ss:dd")
          : "";
        this.workGroup.discontinuityDayTime = response.data.discontinuityDayTime
          ? this.toDateFormat(response.data.discontinuityDayTime, "ss:dd")
          : "";
        this.workGroup.maxLimit = response.data.maxLimit
          ? this.toDateFormat(response.data.maxLimit, "ss:dd")
          : "";
        this.workGroup.minLimit = response.data.minLimit
          ? this.toDateFormat(response.data.minLimit, "ss:dd")
          : "";
        this.workGroup.acceptToEntryDay = response.data.acceptToEntryDay;
        this.workGroup.accessDoorControl = response.data.accessDoorControl;
        this.workGroup.oneOfAllLog = response.data.oneOfAllLog
          ? this.toDateFormat(response.data.oneOfAllLog, "ss:dd")
          : "";
        this.workGroup.deleteDifferentDoors =
          response.data.deleteDifferentDoors;
        this.workGroup.noDeleteOvertime = response.data.noDeleteOvertime;
        this.workGroup.breakTolerances = response.data.breakTolerances;
        this.workGroup.extraWorks = response.data.extraWorks;
        this.workGroup.periods = response.data.periods;
        this.workGroup.extraPayrolls = response.data.extraPayrolls;
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
        this.isLoadingDetail = false;
      }
    },
    async getWorkGroups() {
      try {
        this.isLoading = true;
        const workGroups = [];
        const response = await this.$axios
          .get("/WorkGroups")
          .then(response => {
            response.data.forEach(doc => {
              workGroups.push({
                id: doc.id,
                name: doc.name,
                shortCode: doc.shortCode,
                isPeriod: doc.isPeriod,
                model: doc.model
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.workGroups = workGroups;
        await this.getPeriodDetails();
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getPeriodDetails() {
      try {
        this.isLoadingDetail = true;
        const periodDetails = [];
        const allowences = [];
        await this.workGroups.forEach(doc => {
          periodDetails.push({
            id: doc.id,
            name: doc.shortCode + " - " + doc.name,
            isAllowence: false
          });
        });
        const response = await this.$axios
          .get("/Allowences")
          .then(response => {
            response.data.forEach(doc => {
              periodDetails.push({
                id: doc.id,
                name: doc.shortCode + " - " + doc.name,
                isAllowence: true
              });
              allowences.push({
                id: doc.id,
                name: doc.shortCode + " - " + doc.name,
                isAllowence: true
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.allowences = allowences;
        this.periodDetails = periodDetails;
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingDetail = false;
      }
    },
    async getPayrolls() {
      try {
        const payrolls = [];
        const response = await this.$axios
          .get("/Payroll")
          .then(response => {
            response.data.forEach(doc => {
              payrolls.push({
                id: doc.id,
                shortCode: doc.shortCode,
                name: doc.name,
                type: doc.type,
                otherType: doc.otherPayrollTypes,
                equalType: doc.equalPayroll,
                maxLimit: doc.maxLimit,
                monthlyPayrollId: doc.monthlyPayroll,
                isApproved: doc.isApproved,
                multiplier: doc.multiplier,
                firstTolerance1: doc.firstTolerance1,
                lastTolerance1: doc.lastTolerance1,
                totalTolerance1: doc.totalTolerance1,
                firstTolerance2: doc.firstTolerance2,
                lastTolerance2: doc.lastTolerance2,
                totalTolerance2: doc.totalTolerance2,
                firstTolerance3: doc.firstTolerance3,
                lastTolerance3: doc.lastTolerance3,
                totalTolerance3: doc.totalTolerance3
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.payrolls = payrolls;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async deleteWorkGroup() {
      let id = this.workGroup.id;
      if (id == null) {
        alertify.warning(this.$ml.get('alerts.pleaseSelect'));
      }
      try {
        this.isLoadingDetail = true;
        const response = await this.$axios
          .delete("/WorkGroups/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        if (response.status == 200) {
          alertify.success(this.$ml.get('alerts.deletedSuccessfully'));
          await this.getWorkGroups();
          await this.newWorkGroup();
          this.isLoadingDetail = false;
        } else {
          alertify.error(response.status + " - " + response.message);
          this.isLoadingDetail = false;
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
        this.isLoadingDetail = false;
      }
    },
    async saveWorkGroup() {
      if (
        this.workGroup.isPeriod == true &&
        this.workGroup.periodStartDate == "" && this.workGroup.periodStartDate == null
      ) {
        alertify.warning(this.$ml.get('alerts.pleaseEnterPeriodStartDate'));
        return;
      }
      if (this.workGroup.shortCode == "" || this.workGroup.name == "") {
        alertify.warning(
          this.$ml.get('alerts.pleaseEnterShortCodeAndName')
        );
        return;
      }
      this.isLoadingDetail = true;
      if (this.isNewWorkGroup) {
        try {
          let workGroup2 = this.workGroup;
          const response = await this.$axios
            .post("/WorkGroups", {
              model: workGroup2.model,
              name: workGroup2.name,
              shortCode: workGroup2.shortCode,
              isPeriod: workGroup2.isPeriod,
              periodStartDate: workGroup2.periodStartDate,
              entryTime: workGroup2.entryTime,
              exitTime: workGroup2.exitTime,
              earlyEntryTime: workGroup2.earlyEntryTime,
              earlyExitTime: workGroup2.earlyExitTime,
              lateEntryTime: workGroup2.lateEntryTime,
              lateExitTime: workGroup2.lateExitTime,
              foodStartTime: workGroup2.foodStartTime,
              foodEndTime: workGroup2.foodEndTime,
              foodTotalTime: workGroup2.foodTotalTime,
              totalWorkTime: workGroup2.totalWorkTime,
              totalBreakTime: workGroup2.totalBreakTime,
              totalOverTime: workGroup2.totalOverTime,
              firstEntryLastExit: workGroup2.firstEntryLastExit,
              dayOffHour: workGroup2.dayOffHour,
              solsticeHour: workGroup2.solsticeHour,
              discontinuityDayTime: workGroup2.discontinuityDayTime,
              maxLimit: workGroup2.maxLimit,
              minLimit: workGroup2.minLimit,
              acceptToEntryDay: workGroup2.acceptToEntryDay,
              accessDoorControl: workGroup2.accessDoorControl,
              oneOfAllLog: workGroup2.oneOfAllLog,
              deleteDifferentDoors: workGroup2.deleteDifferentDoors,
              noDeleteOvertime: workGroup2.noDeleteOvertime,
              breakTolerances: workGroup2.breakTolerances,
              extraWorks: workGroup2.extraWorks,
              periods: workGroup2.periods,
              extraPayrolls: workGroup2.extraPayrolls
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get('errors.connectionError'));
                  this.isLoading = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoading = false;
                  return;
                }
              }
            });
          let id = response.data.id;
          if (response.status == 200) {
            alertify.success(this.$ml.get('alerts.savedSuccessfully'));
          } else {
            alertify.error(response.message);
          }
          this.getWorkGroups();
          this.getWorkGroup(id);
          this.isNewWorkGroup = false;
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        try {
          let workGroup2 = this.workGroup;
          const response = await this.$axios
            .post("/WorkGroups/" + workGroup2.id, {
              model: workGroup2.model,
              name: workGroup2.name,
              shortCode: workGroup2.shortCode,
              isPeriod: workGroup2.isPeriod,
              periodStartDate: workGroup2.periodStartDate,
              entryTime: workGroup2.entryTime,
              exitTime: workGroup2.exitTime,
              earlyEntryTime: workGroup2.earlyEntryTime,
              earlyExitTime: workGroup2.earlyExitTime,
              lateEntryTime: workGroup2.lateEntryTime,
              lateExitTime: workGroup2.lateExitTime,
              foodStartTime: workGroup2.foodStartTime,
              foodEndTime: workGroup2.foodEndTime,
              foodTotalTime: workGroup2.foodTotalTime,
              totalWorkTime: workGroup2.totalWorkTime,
              totalBreakTime: workGroup2.totalBreakTime,
              totalOverTime: workGroup2.totalOverTime,
              firstEntryLastExit: workGroup2.firstEntryLastExit,
              dayOffHour: workGroup2.dayOffHour,
              solsticeHour: workGroup2.solsticeHour,
              discontinuityDayTime: workGroup2.discontinuityDayTime,
              maxLimit: workGroup2.maxLimit,
              minLimit: workGroup2.minLimit,
              acceptToEntryDay: workGroup2.acceptToEntryDay,
              accessDoorControl: workGroup2.accessDoorControl,
              oneOfAllLog: workGroup2.oneOfAllLog,
              deleteDifferentDoors: workGroup2.deleteDifferentDoors,
              noDeleteOvertime: workGroup2.noDeleteOvertime,
              breakTolerances: workGroup2.breakTolerances,
              extraWorks: workGroup2.extraWorks,
              periods: workGroup2.periods,
              extraPayrolls: workGroup2.extraPayrolls
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get('errors.connectionError'));
                  this.isLoading = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoading = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            alertify.success(this.$ml.get('alerts.updatedSuccessfully'));
          } else {
            alertify.error(response.message);
          }
          this.getWorkGroups();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      }
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(this.$ml.get('alerts.userIsNotAuthorizedToSeeData'));
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthControl();
    await this.getWorkGroups();
    await this.getPayrolls();
  }
};
</script>

<style scoped>
.step {
  width: 70px;
  height: 70px;
  line-height: 70px;
  display: inline-block;
  border-radius: 100px;
  z-index: 2;
  left: 0;
  text-align: center;
  font-size: 25px;
  color: White;
  margin: 0 10px 0 10px;
  margin-bottom: 30px;
}
.step-primary {
  color: #3c8dbc;
  background-color: White;
  border-style: solid;
  border-color: #3c8dbc;
  line-height: 65px;
}
.step-danger {
  color: #d73925;
  background-color: White;
  border-style: solid;
  border-color: #d73925;
  line-height: 65px;
}
.step-warning {
  color: #f39c12;
  background-color: White;
  border-style: solid;
  border-color: #f39c12;
  line-height: 65px;
}
.step-success {
  color: #00a65a;
  background-color: White;
  border-style: solid;
  border-color: #00a65a;
  line-height: 65px;
}
</style>



// WEBPACK FOOTER //
// src/pages/shifts/Shifts.vue